import { SCORE_META } from "@/lib/api";

const barColor = (v) => (v >= 70 ? "bg-emerald-500" : v >= 45 ? "bg-blue-500" : "bg-amber-500");

export function ScoreBreakdown({ scores }) {
  if (!scores) return <p className="text-[11px] text-zinc-400">No score breakdown available for this concept.</p>;
  return (
    <div className="space-y-1.5" data-testid="score-breakdown">
      {SCORE_META.map((m) => {
        const v = scores[m.key] ?? 0;
        return (
          <div key={m.key}>
            <div className="flex justify-between text-[11px]">
              <span className="text-zinc-600">{m.label} <span className="text-zinc-400">· {Math.round(m.weight * 100)}%</span></span>
              <span className="font-medium text-zinc-700 tabular-nums">{v}</span>
            </div>
            <div className="h-1.5 bg-zinc-100 rounded-full overflow-hidden mt-0.5">
              <div className={`h-full rounded-full ${barColor(v)}`} style={{ width: `${v}%` }} />
            </div>
          </div>
        );
      })}
      <p className="text-[10px] text-zinc-400 pt-1">Weighted rubric · AI-estimated, not from live sales data.</p>
    </div>
  );
}
